import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { VideoBanner } from './components/Video/VideoBanner';
import { Navbar } from './components/NavBar/NavBar';
import { HeroSection } from './components/HeroSection/HeroSection';
import { CarBrands } from './components/CarBrands/CarBrands';
import { Working } from './components/Working/Working';
import { Services } from './components/Services/Services';
import { Download } from './components/Download/Download';
import { Footer } from './components/Footer/Footer';
import { ProductCarousel } from './components/ProductCarousel/ProductCarousel';
import { TeamCarousel } from './components/TeamCarousel/TeamCarousel';
import { StickyVideoNote } from './components/StickyVideoNote/StickyVideoNote';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <VideoBanner />
              <HeroSection />
              <CarBrands />
              <Working />
              <Services />
              <Download />
              <TeamCarousel />
              <Footer />
              <StickyVideoNote/>
            </>
          }
        />
        {/* <Route path="/product-page" element={<ProductPage />} /> */}
      </Routes>
    </Router>
  );
}
